/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ConfirmInputs */

const zh_common_confirm = /** @type {(inputs: Common_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const en_common_confirm = /** @type {(inputs: Common_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const es_common_confirm = /** @type {(inputs: Common_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Common_ConfirmInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_confirm = /** @type {((inputs?: Common_ConfirmInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ConfirmInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_confirm(inputs)
	if (locale === "en") return en_common_confirm(inputs)
	return es_common_confirm(inputs)
});